import type { Branch, BranchId } from "~/branching/model/branch";

export function resolveDefaultBranch(branches: Branch[]): Branch | null {
  return (
    branches.find((branch) => branch.isDefault) ?? branches.find((branch) => !branch.isArchived) ?? branches[0] ?? null
  );
}

export function resolveBranchIdForRoute(branch: Branch, branches: Branch[]): BranchId | null {
  if (branch.isDefault) {
    return null;
  }

  const defaultBranch = resolveDefaultBranch(branches);
  if (defaultBranch != null && branch.id === defaultBranch.id) {
    return null;
  }

  return branch.id;
}
